/*! site.js 1.5.0 */
import '../../polyfill';
import 'what-input';
import Vue from 'vue';

import v1 from '../../v1/v1';
import v1Permission from '../../v1/v1Permission';
import v1Header from '../../v1/v1Header';
import v1Footer from '../../v1/v1Footer';
import v1JsSmoothScroll from '../../v1/v1JsSmoothScroll';
import v1BackToTop from '../../v1/v1BackToTop';
import v1JsExternalLink from '../../v1/v1JsExternalLink';
import v1Breadcrumb from '../../v1/v1Breadcrumb';
import v1UpdateData from '../../v1/v1UpdateDate';
import v1Result from '../../v1/v1Result';
import v1TopNews from '../../v1/v1TopNews';
import v1TopCarousel from '../../v1/v1TopCarousel';
import v1TopCarouselArea from '../../v1/v1TopCarouselArea';
import v1TopCarouselSeason from '../../v1/v1TopCarouselSeason';
import v1DestinationsCheck from '../../v1/v1DestinationsCheck';
import v1DestinationsHeader from '../../v1/v1DestinationsHeader';
import v1Itinerary from '../../v1/v1Itinerary';
import v1JsRecommendationHero from '../../v1/v1JsRecommendationHero';
import v1ItineraryHero from '../../v1/v1ItineraryHero';
import v1RecommendationTopCarousel from '../../v1/v1RecommendationTopCarousel';
import v1Features from '../../v1/v1Features';
import v1Seasons from '../../v1/v1Seasons';
import v1Dialog from '../../v1/v1Dialog';
import v1ItinerarySpot from '../../v1/v1ItinerarySpot';
import contentItineraryMap from '../../v1/v1ItineraryMap';
import contentDomesticFlights from '../../v1/domesticFlights';
import currentCountryOnly from '../../v1/currentCountryOnly';
import v1FlightInformation from '../../v1/v1FlightInformation.vue';
import v1Tailored from '../../v1/v1Tailored';
import displayInView from '../../v1/displayInView';
import v1TottoriHiddenGem from '../../v1/v1TottoriHiddenGem';

import lpKansaiByRail from '../../lp/kansaiByRail';
import luxuryInOkinawa from '../../lp/luxuryInOkinawa';

v1();
v1Permission();
const background = document.getElementById('js-recommendationHero__html5_api');
const background2 = document.getElementById('v1-itineraryHero__bg_html5_api');
if (background) v1JsRecommendationHero(background);
if (background2) v1ItineraryHero(background2);

function v1FlightInfomation() {
  const v1FlightInfomationElm = document.getElementById('v1-flight-information');

  if (!v1FlightInfomationElm) return;

  const vm = new Vue({
    components: {
      v1FlightInformation,
    },
  });

  vm.$mount('#v1-flight-information');
}
v1FlightInfomation();

const countrySwitchContent = [].slice.call(document.querySelectorAll('[data-countrycode]'));
if (countrySwitchContent) currentCountryOnly(countrySwitchContent);

const spotArea = document.getElementById('v1-itinerarySpot');
if (spotArea) v1ItinerarySpot(spotArea);
const mapArea = document.getElementById('v1-itineraryMap__map');
if (mapArea) contentItineraryMap(mapArea);
const searchLink = [].slice.call(document.querySelectorAll('[name="CONNECTION_KIND"]'));
if (searchLink) contentDomesticFlights(searchLink);

v1Header();
v1Footer();
v1JsSmoothScroll();
v1BackToTop();
v1JsExternalLink();
v1Breadcrumb();
v1UpdateData();
v1Result();
v1TopNews();
v1TopCarousel();
v1TopCarouselArea();
v1TopCarouselSeason();
v1DestinationsCheck();
v1DestinationsHeader();
v1Itinerary();
v1RecommendationTopCarousel();
v1Features();
v1Seasons();
v1Dialog();
v1Tailored();
displayInView();
v1TottoriHiddenGem();

// LP
const KansaiByRail = document.querySelector('.v1-kansaiByRail');
if (KansaiByRail) lpKansaiByRail(KansaiByRail);

luxuryInOkinawa();
